var LetterSeeAlso = React.createClass({
	mixins: [React.addons.PureRenderMixin],

	render: function () {
		return (
			<Box>
				<hr />
			</Box>
		)
	},
})
